import React, { useCallback } from "react";

const DropArea = ({ onDrop, children }) => { 
  const handleDrop = useCallback((e) => {
    e.preventDefault();
    const data = e.dataTransfer.getData("text");
    onDrop(data);
  }, [onDrop]);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
  }, []);

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      style={{
        width: "100%",
        height: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px dashed #ccc",
        borderRadius: "5px",
      }}
    >
      {children}
    </div>
  );
};

export default DropArea;
